var React = require('react');

function Navigator (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h20v20H0z","key":0}),React.createElement("path",{"d":"M16.131 3.69a.5.5 0 0 0-.65-.652L2.312 8.374a.5.5 0 0 0 .02.934l5.313 1.893a.5.5 0 0 1 .303.303l1.9 5.303a.5.5 0 0 0 .933.02l5.35-13.137Z","fill":"#fff","key":1})]);
}

Navigator.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Navigator;

Navigator.default = Navigator;
